module.exports = __webpack_public_path__ + "static/media/selected_users.a99332cc.svg";